import Styles from '../SingleMenuDropdown/SingleMenuDropdown.module.scss'
import { InsertImageButton } from 'components/DocRightRail/screens/InsertMenu/InsertButtons/InsertImageButton'
import { InsertCoverImageButton } from 'components/DocRightRail/screens/InsertMenu/InsertButtons/InsertCoverImageButton'
import { InsertEmbedButton } from 'components/DocRightRail/screens/InsertMenu/InsertButtons/InsertEmbedButton'
import { InsertLinkButton } from 'components/DocRightRail/screens/InsertMenu/InsertButtons/InsertLinkButton'
import { InsertMentionButton } from 'components/DocRightRail/screens/InsertMenu/InsertButtons/InsertMentionButton'
import { InsertTableOfContents } from 'components/DocRightRail/screens/InsertMenu/InsertButtons/InsertTableOfContents'
import { InsertCodeBlockButton } from 'components/DocRightRail/screens/InsertMenu/InsertButtons/InsertCodeBlockButton'
import { InsertDiagramButton } from 'components/DocRightRail/screens/InsertMenu/InsertButtons/InsertDiagramButton'
import { InsertTableButton } from 'components/DocRightRail/screens/InsertMenu/InsertButtons/InsertTableButton/InsertTableButton'
import { InsertLineDividerButton } from 'components/DocRightRail/screens/InsertMenu/InsertButtons/InsertLineDividerButton/InsertLineDividerButton'
import { SimpleDropdown } from '../SimpleDropdown/SimpleDropdown'
import { SimpleDropdownItem } from '../SimpleDropdown/SimpleDropdownItem'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const InsertDropdown = () => {
  const { isMobile } = useResponsiveDesign()
  return (
    <SimpleDropdown
      aria-label="Insert"
      tooltip={{ label: 'Insert' }}
      placement="bottom"
      bodyClassName={Styles.dropdownBody}
      buttonClassName={Styles.button}
      hasChevron={false}
    >
      <>
        <ToolbarIcon name={IconName.AddElements} />
        {!isMobile && <span className={Styles.label}>Elements</span>}
      </>
      <>
        <InsertImageButton />
        <SimpleDropdown aria-label="Insert Table" placement="right-start" isSubmenu>
          <SimpleDropdownItem icon={<ToolbarIcon name={IconName.Table} />} label="Table" withChevron />
          <InsertTableButton isSubmenu />
        </SimpleDropdown>
        <InsertEmbedButton />
        <span className={Styles.lineDivider} />
        <InsertCoverImageButton />
        <InsertDiagramButton />

        <SimpleDropdown aria-label="Insert Divider" placement="right-start" isSubmenu>
          <SimpleDropdownItem icon={<ToolbarIcon name={IconName.Divider} />} label="Divider" withChevron />
          <InsertLineDividerButton isSubmenu />
        </SimpleDropdown>
        <InsertCodeBlockButton />
        <InsertTableOfContents />
        <InsertLinkButton />
        <InsertMentionButton />
      </>
    </SimpleDropdown>
  )
}
